import React, { useState } from 'react';
import RefundComponent from './list-refund.component';
const RefundList = (props) => {
    const [offrange, setOffrange] = useState(true);

    return <RefundComponent {...props} offrange={offrange} setOffrange={setOffrange} />;
};

export default RefundList;
